export var removeHtmlTags = function removeHtmlTags(str) {
  if (typeof str !== 'string') return '';
  var regex = /(&nbsp;|<([^>]+)>)/gi;
  return str.replace(regex, '').trim();
};
export var getSuggestionRegionTitle = function getSuggestionRegionTitle(_ref) {
  var city = _ref.city,
    customCity = _ref.customCity,
    area = _ref.area;
  var title = city ? removeHtmlTags(city) : customCity;
  // eslint-disable-next-line sonarjs/no-nested-template-literals
  return title ? "".concat(title).concat(area ? " (".concat(area, ")") : '') : area;
};